import TabSwitch, { TabSwitchItem } from "@common/component/TabSwitch";
import React, { useState } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { NavigationSwitchScreenProps } from "react-navigation";
import { ListSearchInput } from "../../../common/component";
import DispatchInventory from "../InventoryListingV3.1/DispatchInventory";
import OutboundInventory from "../InventoryListingV3.1/OutboundInventory";
import { InventoryTypeEnum, InventoryTypesList } from "../InventoryListingV3.1/constants";
import JobCardListing from "./JobCardListing";
import { useDebounce } from "../../../hooks/useDebounce";

interface JobCardListingV3Props extends NavigationSwitchScreenProps {}

function JobCardListingV3(props: JobCardListingV3Props) {
  const { navigation } = props;
  const { search: searchParam = "", inventoryType: inventoryTypeParam = "" } = navigation.state?.params ?? {};

  const [search, setSearch] = useState(searchParam ? searchParam : "");
  const [inventoryType, setInventoryType] = useState(
    () => InventoryTypesList.find((it) => it.value === inventoryTypeParam) || InventoryTypesList[0]
  );
  const debouncedSearch = useDebounce(search, 500);

  const onSelectInventoryType = (item: TabSwitchItem) => {
    setInventoryType(item);
    navigation.setParams({ inventoryType: item.value });
  };

  const handleSearch = (text: string) => {
    setSearch(text);
    if(text === ""){
      navigation.setParams({ search: undefined });
    }else{
      navigation.setParams({ search: text });
    }
  };

  return (
    <>
      <ScrollView style={styles.container}>
        <View style={styles.flexBox}>
          <TabSwitch items={InventoryTypesList} value={inventoryType} onSelect={onSelectInventoryType} />
          <ListSearchInput
            searchProp={search}
            onSearch={handleSearch}
            debouncedSearchEnable={true}
            placeholder={
              inventoryType.value === InventoryTypeEnum.Refurb
                ? "Search lead ID, cars, CGT..."
                : "Search lead ID, cars, technician, inspector..."
            }
          />
        </View>
        {inventoryType.value === InventoryTypeEnum.Refurb && <JobCardListing {...props} search={debouncedSearch} setSearch={setSearch} />}
        {inventoryType.value === InventoryTypeEnum.Outbound && (
          <OutboundInventory navigation={navigation} search={debouncedSearch} />
        )}
        {inventoryType.value === InventoryTypeEnum.Dispatch && (
          <DispatchInventory navigation={navigation} search={debouncedSearch} />
        )}
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    // @ts-ignore
    padding: "1.2em",
  },
  flexBox: { flexDirection: "row", alignItems: "center", justifyContent: "space-between" },
});

export default JobCardListingV3;
